import React, { useState } from 'react';
import api from '../../services/api';
import toastr from 'toastr';

export default function AdminPanel({
    presence, globalMutedUntil,
    onClearAll, onMuteGlobal, onMuteUser, onRefreshPresence,
    knownUsers, open, onClose
}) {
    const [muteMin, setMuteMin] = useState(15);
    const [muteUserLogin, setMuteUserLogin] = useState('');
    const [confirmClear, setConfirmClear] = useState(false);

    const muteGlobal = async (minutes) => {
        try {
            await api.chat.muteGlobal(minutes);
            toastr.success(' ', minutes ? `Глобальный мут на ${minutes} мин.` : 'Мут снят.');
            onMuteGlobal && onMuteGlobal();
        } catch (e) { toastr.warning(' ', e.response?.data?.message || 'Ошибка.'); }
    };
    const muteUser = async () => {
        if (!muteUserLogin.trim()) { toastr.warning(' ', 'Выберите пользователя.'); return; }
        try {
            await api.chat.muteUser(muteUserLogin.trim(), muteMin);
            toastr.success(' ', muteMin ? `${muteUserLogin} заглушен на ${muteMin} мин.` : `Мут с ${muteUserLogin} снят.`);
            setMuteUserLogin('');
        } catch (e) { toastr.warning(' ', e.response?.data?.message || 'Ошибка.'); }
    };

    const doClearAll = () => {
        onClearAll && onClearAll();
        setConfirmClear(false);
    };

    // Только не-админы как кандидаты на мут
    const muteCandidates = (knownUsers || []).filter(u => u.role !== 'admin');

    return (
        <aside className={`pchat-aside ${open ? 'open' : ''}`}>
            <div className="pchat-aside-section">
                <div className="pchat-aside-title">
                    <span>В чате сейчас ({presence.length})</span>
                    <span style={{ display: 'flex', gap: 4 }}>
                        <button className="pchat-aside-btn icon-only" onClick={onRefreshPresence} title="Обновить">↻</button>
                        {onClose && (
                            <button className="pchat-aside-btn icon-only" onClick={onClose} title="Закрыть">✕</button>
                        )}
                    </span>
                </div>
                <ul className="pchat-presence-list">
                    {presence.map(p => (
                        <li key={p.login}><span className="pchat-online-dot" />{p.login}</li>
                    ))}
                    {presence.length === 0 && <li className="pchat-presence-empty">никого</li>}
                </ul>
            </div>

            <div className="pchat-aside-section">
                <div className="pchat-aside-title">Глобальный мут</div>
                {globalMutedUntil && (
                    <div className="pchat-mute-info">
                        До {new Date(globalMutedUntil).toLocaleString('ru-RU')}
                    </div>
                )}
                <button className="pchat-aside-btn" onClick={() => muteGlobal(5)}>🔇 Заглушить 5 мин</button>
                <button className="pchat-aside-btn" onClick={() => muteGlobal(60)}>🔇 Заглушить 1 час</button>
                <button className="pchat-aside-btn" onClick={() => muteGlobal(60 * 24)}>🔇 Заглушить 1 день</button>
                <button className="pchat-aside-btn" onClick={() => muteGlobal(0)}>🔊 Снять мут</button>
            </div>

            <div className="pchat-aside-section">
                <div className="pchat-aside-title">Мут пользователя</div>
                <select
                    className="pchat-aside-input"
                    value={muteUserLogin}
                    onChange={e => setMuteUserLogin(e.target.value)}
                >
                    <option value="">— выберите пользователя —</option>
                    {muteCandidates.map(u => (
                        <option key={u.login} value={u.login}>{u.login}</option>
                    ))}
                </select>
                <select
                    className="pchat-aside-input"
                    value={muteMin}
                    onChange={e => setMuteMin(parseInt(e.target.value, 10))}
                >
                    <option value={5}>5 минут</option>
                    <option value={15}>15 минут</option>
                    <option value={60}>1 час</option>
                    <option value={60 * 6}>6 часов</option>
                    <option value={60 * 24}>1 день</option>
                    <option value={60 * 24 * 7}>7 дней</option>
                    <option value={0}>Снять мут</option>
                </select>
                <button className="pchat-aside-btn" onClick={muteUser}>Применить</button>
            </div>

            <div className="pchat-aside-section">
                <div className="pchat-aside-title" style={{ color: '#ff7878' }}>Опасное</div>
                {!confirmClear ? (
                    <button className="pchat-aside-btn danger" onClick={() => setConfirmClear(true)}>
                        🗑 Очистить ВСЮ историю
                    </button>
                ) : (
                    <>
                        <div className="pchat-mute-info" style={{ background: '#5a2a2a' }}>
                            Удалить ВСЕ сообщения и файлы для всех? Необратимо.
                        </div>
                        <button className="pchat-aside-btn danger" onClick={doClearAll}>Да, удалить</button>
                        <button className="pchat-aside-btn" onClick={() => setConfirmClear(false)}>Отмена</button>
                    </>
                )}
            </div>
        </aside>
    );
}
